import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { CreateChancel, CustomizedSwitch, InputMain } from 'components';
import { FindLoad, FindSuccessItem, Images, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';
import { clearHouseTypeEnums } from '../constants';

// const ACTION_TYPE = 'CONNECT_OFFICE_ALLY';
const ACTION_TYPE = 'CONNECT_INTEGRATION';
export const ConnectOfficeAlly = () => {
    const { close } = useModal();
    const { handleSubmit, control } = useForm();
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const [sftpPollingEnabled, setSftpPollingEnabled] = useState(false);
    const [showPassword, setShowPassword] = useState({
        sftpPassword: false,
        soapPassword: false,
    });

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [success]);

    const handleCreate = (data) => {
        // dispatch(systemActions.connectOfficeAlly({

        dispatch(
            systemActions.connectIntegration({
                officeAlly: {
                    sftpPollingEnabled: sftpPollingEnabled,
                    sftpCredentials: {
                        username: data.sftpUsername,
                        password: data.sftpPassword,
                    },
                    // soapCredentials: {
                    //     username: data.sftpUsername,
                    //     password: data?.soapPassword,
                    //     senderId: data?.soapSenderId,
                    //     receiverId: data?.soapReceiverId,
                    // },
                },
                clearinghouseType: clearHouseTypeEnums.OFFICE_ALLY,
            })
        );
    };

    const toggleShowPassword = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    return (
        <div style={{ width: 400 }}>
            <div className="office-ally-header">
                <div className="office-ally-header-icons">
                    <div>
                        <img src={Images.logoSmall} alt="" />
                    </div>
                    <img src={Images.compareArrows} alt="arrow" />
                    <div>
                        <img src={Images.officeAlly} alt="" />
                    </div>
                </div>
                <p>Connect to Office Ally</p>
            </div>
            <form onSubmit={handleSubmit(handleCreate)}>
                <p className="integration-title-text" style={{ marginBottom: 16 }}>SFTP Credentials</p>
                <InputMain
                    label={'SFTP Username*'}
                    customClass={true}
                    variant="outlined"
                    name="sftpUsername"
                    type="text"
                    control={control}
                    placeholder="Enter username"
                    rules={{
                        required: 'Username is required.',
                    }}
                />
                <InputMain
                    label={'SFTP Password*'}
                    customClass={true}
                    variant="outlined"
                    name="sftpPassword"
                    type="password"
                    showPassword={showPassword?.sftpPassword}
                    control={control}
                    placeholder="Enter password"
                    rules={{
                        required: 'SFTP Password is required.',
                    }}
                    onClickIconEnd={() => toggleShowPassword('sftpPassword')}
                />

                <div className="flex-align-start" style={{ gap: 4, marginBottom: 12 }}>
                    <img src={Images.toolInfoIcon} alt="info" style={{ marginTop: 3 }} />
                    <p className="files-sftp-folder">
                        Files in the configured SFTP folder may be processed, moved, archived, or deleted automatically by TherapyLake.
                    </p>
                    <CustomizedSwitch checked={sftpPollingEnabled} handleClick={() => setSftpPollingEnabled(!sftpPollingEnabled)} />
                </div>


                {/*<p className="integration-title-text">SOAP Credentials</p>*/}
                {/*<InputMain*/}
                {/*    label={'SOAP Password'}*/}
                {/*    customClass={true}*/}
                {/*    variant="outlined"*/}
                {/*    name="soapPassword"*/}
                {/*    type="password"*/}
                {/*    showPassword={showPassword?.soapPassword}*/}
                {/*    control={control}*/}
                {/*    placeholder="Enter password"*/}
                {/*    onClickIconEnd={() => toggleShowPassword('soapPassword')}*/}
                {/*/>*/}
                {/*<InputMain*/}
                {/*    label={'Sender ID'}*/}
                {/*    customClass={true}*/}
                {/*    variant="outlined"*/}
                {/*    name="soapSenderId"*/}
                {/*    type="text"*/}
                {/*    control={control}*/}
                {/*    placeholder="Enter Sender ID"*/}
                {/*/>*/}
                {/*<InputMain*/}
                {/*    label={'Receiver ID'}*/}
                {/*    customClass={true}*/}
                {/*    variant="outlined"*/}
                {/*    name="soapReceiverId"*/}
                {/*    type="text"*/}
                {/*    control={control}*/}
                {/*    placeholder="Enter Receiver ID"*/}
                {/*/>*/}
                <div className="office-ally-info-box">
                    <img src={Images.toolInfoIcon} alt={'icon'} />
                    <p>Your SOAP Username is the same as your SFTP Username. It will be auto-filled for you.</p>
                </div>

                <div style={{ marginTop: 24 }}>
                    <CreateChancel
                        type="submit"
                        loader={!!loader.length}
                        create={'Connect'}
                        chancel={'Cancel'}
                        onClose={close}
                        buttonWidth={'100%'}
                    />
                </div>
            </form>
        </div>
    );
};
